<template>
  <div>
    <page-header title="تنظیمات فوتر" subtitle="شبکه‌های اجتماعی و اطلاعات تماسی که در پایین همه صفحات سایت نمایش داده می‌شوند."></page-header>

    <v-card class="settings-card" v-for="group in groups" :key="group.title">
      <v-card-title><v-icon left>{{ group.icon }}</v-icon>{{ group.title }}</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="6" lg="4" v-for="field in group.fields" :key="field.name">
            <v-text-field v-model="footer[field.name]"
                          :label="field.label"
                          :prepend-inner-icon="field.icon"
                          :dir="field.ltr ? 'ltr' : null"
                          color="#00ADB5" outlined dense></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div class="form-actions">
      <v-btn class="btn-primary" large depressed @click="updateContent">
        <v-icon left>mdi-content-save</v-icon>
        ذخیره تغییرات
      </v-btn>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader.vue";

export default {
    name: "FooterSetting",

    components: {PageHeader},

    data() {
        return {
            footer: {},
            groups: [
                {
                    title: 'شبکه‌های اجتماعی',
                    icon: 'mdi-share-variant',
                    fields: [
                        {name: 'instagram', label: 'اینستاگرام', icon: 'mdi-instagram', ltr: true},
                        {name: 'telegram', label: 'تلگرام', icon: 'mdi-send', ltr: true},
                        {name: 'whatsapp', label: 'واتس‌اپ', icon: 'mdi-whatsapp', ltr: true},
                        {name: 'gmail', label: 'ایمیل', icon: 'mdi-email', ltr: true},
                        {name: 'youtube', label: 'یوتیوب', icon: 'mdi-youtube', ltr: true},
                        {name: 'aparat', label: 'آپارات', icon: 'mdi-movie-roll', ltr: true},
                    ],
                },
                {
                    title: 'اطلاعات تماس',
                    icon: 'mdi-phone',
                    fields: [
                        {name: 'mobile', label: 'موبایل', icon: 'mdi-cellphone', ltr: true},
                        {name: 'phone', label: 'تلفن', icon: 'mdi-phone', ltr: true},
                        {name: 'address', label: 'آدرس', icon: 'mdi-map-marker'},
                    ],
                },
            ],
        }
    },

    mounted() {
        this.getFooter()
    },

    methods: {
        getFooter() {
            this.$store.dispatch("getFooterContent").then((res) => {
                this.footer = res.data
            })
        },

        updateContent() {
            console.log(this.footer)
            this.$store.dispatch("updateFooter", this.footer).then(() => {
                this.getFooter()
            })
        },
    }
}
</script>

<style scoped>

</style>